import React from 'react';
import PropTypes from 'prop-types';
import { Icon, grey600 } from '@paypalcorp/pp-react';
import { StyleSheet, css } from '../../utility/paypalAphrodite';

const styles = StyleSheet.create({
  iconLink: {
    cursor: 'pointer',
    color: grey600,
    marginRight: '0.375rem',
  },
});

function SocialShareMobile({ handleMobileClick, linkTitle }) {
  return (
    <Icon
      name="share-mobile"
      onClick={handleMobileClick}
      className={`${css(styles.iconLink)}`}
      title={linkTitle}
      role="link"
      tabIndex="0"
      data-testid="social-share-mobile"
      size="lg"
    />
  );
}

SocialShareMobile.propTypes = {
  handleMobileClick: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareMobile;
